import { render, staticRenderFns } from "./OpenCustomerECatalogueLayout.vue?vue&type=template&id=308c41c6"
import script from "./OpenCustomerECatalogueLayout.vue?vue&type=script&lang=js"
export * from "./OpenCustomerECatalogueLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports